/**
 * Промежуточное хранение mfa_token между шагом логина и шагом 2FA.
 *
 * Держим в sessionStorage (живёт до закрытия вкладки), а не в localStorage —
 * это короткоживущий промежуточный токен, не полноценная сессия.
 */
const MFA_TOKEN_KEY = 'hsc_admin_mfa_token';

export function stashMfaToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(MFA_TOKEN_KEY, token);
  } catch {
    // игнорируем
  }
}

export function readMfaToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(MFA_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function clearMfaToken(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(MFA_TOKEN_KEY);
  } catch {
    // игнорируем
  }
}
